
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { BeforeStart } from '../../model/ngrx/before-start.model';

export const ADD_BEFORE_START = '[BEFORESTART] Add';
export const REMOVE_BEFORE_START = '[BEFORESTART] Remove';

// AddPersonalDetails
export class AddBeforeStart implements Action {
    readonly type = ADD_BEFORE_START;

    constructor(public payload: BeforeStart) { }
}
// RemovePersonalDetails
export class RemoveBeforeStart implements Action {
    readonly type = REMOVE_BEFORE_START;
  
    constructor(public payload: number) { 
    }
}

export type Actions = AddBeforeStart | RemoveBeforeStart;
